import {
    IconAnimals,
    IconBriefcase,
    IconDroplet,
    IconCalculator,
    IconGear,
    IconHome,
    IconLineage,
    IconLock,
    IconScale,
    IconUpload,
    IconUsers,
} from '../../common/icons';

// Sidebar catalog. Each item declares the permission needed to SEE it
// (domain + action) — the sidebar filters with can() (TSS vite/05: can()
// is allowed outside JSX, in a builder). Items without `domain` are visible
// to any authenticated user. Routes are wired in app/admin-shell + app.jsx.
//
// Permission domains/actions mirror api-reference (decisions/0007):
//   animals/semen/labs/races/farms/clients : read|write   ·  aspirations : read|write

export const NAV_SECTIONS = [
    {
        title: null,
        items: [
            { label: 'Inicio',     to: '/admin/dashboard', icon: <IconHome /> },
            // Planeación agrupa Tareas + Partos + Planear OPU (SectionTabs en sus layouts)
            // → activePaths mantiene el ítem resaltado en las tres pestañas.
            { label: 'Planeación', to: '/admin/tasks',     icon: <IconBriefcase />, domain: 'kpis', action: 'read', activePaths: ['/admin/tasks', '/admin/planning', '/admin/planning/dx', '/admin/opu-planning'] },
        ],
    },
    {
        title: 'Reproducción',
        items: [
            // Banco de embriones y Laboratorios viven como pestañas de Sesiones OPU
            // (SectionTabs en sus overviews) → activePaths mantiene el ítem resaltado.
            { label: 'Sesiones OPU', to: '/admin/opu', icon: <IconDroplet />, domain: 'aspirations', action: 'read', activePaths: ['/admin/opu', '/admin/embryos', '/admin/labs'] },
        ],
    },
    {
        title: 'Negocios',
        items: [
            // Ventas de crías vive como pestaña de Cruces proyecto → activePaths lo resalta.
            { label: 'Cruces proyecto', to: '/admin/projected-crosses', icon: <IconLineage />,    domain: 'projected_crosses', action: 'read', activePaths: ['/admin/projected-crosses', '/admin/sales'] },
            { label: 'Facturación',     to: '/admin/billing',          icon: <IconCalculator />, domain: 'billing',           action: 'read' },
        ],
    },
    {
        title: 'Catálogo',
        items: [
            // Semen, ASOCEBU y Razas viven como pestañas de Animales, y Fincas como pestaña
            // de Clientes (SectionTabs en sus overviews) → activePaths mantiene el resaltado.
            { label: 'Animales', to: '/admin/animals', icon: <IconAnimals />, domain: 'animals', action: 'read', activePaths: ['/admin/animals', '/admin/recipients', '/admin/toros', '/admin/semen', '/admin/asocebu', '/admin/races'] },
            { label: 'Clientes', to: '/admin/clients', icon: <IconUsers />,   domain: 'clients', action: 'read', activePaths: ['/admin/clients', '/admin/farms'] },
        ],
    },
    {
        title: 'Servicios',
        items: [
            // Notificaciones (plantillas de mensajería). A futuro: comunicados + programador,
            // como pestañas de la misma sección → activePaths mantiene el ítem resaltado.
            { label: 'Notificaciones', to: '/admin/notifications', icon: <IconGear />, domain: 'notifications', action: 'read', activePaths: ['/admin/notifications'] },
        ],
    },
    {
        title: 'Integraciones',
        items: [
            { label: 'Software Ganadero', to: '/admin/sg', icon: <IconUpload />, domain: 'sg', action: 'read' },
        ],
    },
    {
        title: 'Administración',
        items: [
            { label: 'Usuarios',  to: '/admin/users',        icon: <IconLock />,  domain: 'users',   action: 'read' },
            // Auditoría agrupa acciones administrativas sensibles (Merges y, a futuro, más).
            // Visible a quien pueda administrar (`:admin`) — admin/webmaster por wildcard.
            { label: 'Auditoría', to: '/admin/audit/merges', icon: <IconScale />, domain: 'animals', action: 'admin', activePaths: ['/admin/audit', '/admin/audit/merges', '/admin/audit/eliminaciones'] },
        ],
    },
];
